import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { ExerciseService } from 'app/shared/services/exercises.service';
import { Program } from 'app/shared/models/Program';
import { Exercise } from '../../../shared/models/Exercises';
import { ExpansionPanelComponent } from '../expansion-panel/expansion-panel.component';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { SnackbarService, SnackbarType } from '../snackbar/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { Category } from '../../../shared/models/Category';
import { CategoryFilterModule } from '../../../shared/pipes/category-filter/category-filter.module';

@Component({
  selector: 'app-mp-dialog',
  templateUrl: './mp-dialog.component.html',
  styleUrls: ['./mp-dialog.component.scss'],
})
export class MpDialogComponent implements OnInit {
  @ViewChild('selection') exercisesOfMyPrograms: ExpansionPanelComponent;
  @Input() title: string;
  /** all exercises available */
  public exercises: Exercise[] = [];
  /** user selected exercises */
  public selectedExercises: Exercise[] = [];
  /** all user created programs */
  private myPrograms: Program[] = [];
  /** current editing program */
  public currentProgram: Program;

  mainCategories: Category[] = [];
  filterargs: any;

  private isNew: boolean = true;

  public isKids: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<MpDialogComponent>,
    private exerciseService: ExerciseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
    this.currentProgram = data as Program;

    this.exerciseService.getMainCategories().then((categories) => (this.mainCategories = categories));

    this.exerciseService.getAllExercises().then((exercises) => (this.exercises = exercises));

    this.exerciseService.getModules().then((modules) => {
      if (modules) {
        let isKids = modules.some((mod) => {
          return mod.title.internal.includes('Kids');
        });
        this.isKids = isKids;
      }
    });

    this.exerciseService.getMyPrograms().then((programs) => {
      this.myPrograms = programs || [];

      if (programs.includes(this.currentProgram)) {
        this.showExercisesOfMyProgram(this.currentProgram.exerciseIds);
        this.isNew = false;
      } else {
        this.currentProgram = new Program();

        translate
          .get('EXERCISES.EDITOR.defaultProgramTitle', { number: this.myPrograms.length + 1 })
          .subscribe((res: string) => {
            this.currentProgram.title = res;
          });
      }
    });
  }

  filter(cat?: Category) {
    this.filterargs = null;
    if (cat) {
      this.filterargs = cat._id;
    }
  }

  ngOnInit() {}

  showExercisesOfMyProgram(exerciseId: string[]) {
    // Comparison of this exerciseIds with Ids in all exercises
    for (const item of exerciseId) {
      // Go through each item of exerciseId to assign to Arrayitem of selectedExercises
      this.selectedExercises.push(this.exercises.find((x) => x._id === item)); // find selected exercises and show them on the bottom
    }
  }

  toggleSelection(ex: any): void {
    if (this.selectedExercises.includes(ex)) {
      this.selectedExercises = this.selectedExercises.filter((item) => item !== ex);
    } else if (this.selectedExercises.length < 3) {
      this.selectedExercises.push(ex);
      if (this.selectedExercises.length === 3) {
        this.exercisesOfMyPrograms.setStep(1);
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  createNewMyProgram() {
    this.currentProgram.exerciseIds = [];

    for (const item of this.selectedExercises) {
      this.currentProgram.exerciseIds.push(item._id);
    }
    this.currentProgram.exercises = this.selectedExercises;
    this.currentProgram.previewUrl = this.currentProgram.exercises[0].previewUrl;

    if (this.isNew) {
      this.exerciseService
        .saveNewProgram(this.currentProgram)
        .then((result) => {
          this.translate
            .get('EXERCISES.EDITOR.ALERT.saveNewSuccess', { title: this.currentProgram.title })
            .subscribe((message: string) => {
              this.snackBar.open(message, null, {
                verticalPosition: 'bottom',
                duration: 4000,
                panelClass: ['b2a-success', 'bottom'],
              });
              this.closeDialog();
            });
        })
        .catch((error) => {
          this.translate
            .get('EXERCISES.EDITOR.ALERT.saveNewError', { title: this.currentProgram.title })
            .subscribe((message: string) => {
              this.snackBar.open(message, null, {
                verticalPosition: 'bottom',
                duration: 4000,
                panelClass: ['b2a-error', 'bottom'],
              });
            });
        });
    } else {
      this.exerciseService
        .updateMyProgram(this.currentProgram)
        .then((result) => {
          this.translate
            .get('EXERCISES.EDITOR.ALERT.saveSuccess', { title: this.currentProgram.title })
            .subscribe((message: string) => {
              this.snackBar.open(message, null, {
                verticalPosition: 'bottom',
                duration: 4000,
                panelClass: ['b2a-success', 'bottom'],
              });
              this.closeDialog();
            });
        })
        .catch((error) => {
          this.translate
            .get('EXERCISES.EDITOR.ALERT.saveError', { title: this.currentProgram.title })
            .subscribe((message: string) => {
              this.snackBar.open(message, null, {
                verticalPosition: 'bottom',
                duration: 4000,
                panelClass: ['b2a-error', 'bottom'],
              });
            });
        });
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/mp-dialog/mp-dialog.component.ts